export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9674.d701a7fc.jpg";